import { Injectable, signal } from '@angular/core';
import { GroupBaseModel } from '@smarttask-common/src/lib/models/Group/Core/GroupBaseModel';
import { DefaultSetupGroupModel } from '@smarttask-common/src/lib/models/Internal/DefaultSetup/DefaultSetupGroupModel';
import { DefaultSetupProjectModel } from '@smarttask-common/src/lib/models/Internal/DefaultSetup/DefaultSetupProjectModel';
import { InternalRegistrationVerticalEnum } from '@smarttask-common/src/lib/models/Internal/RegistrationGoal/InternalRegistrationVerticalEnum';
import { ProjectCopyModel } from '@smarttask-common/src/lib/models/Project/Copy/ProjectCopyModel';
import { Globals } from '@smarttask-common/src/lib/services/globals';
import { OrganizationStoreService } from '../../Organization/store/organizationStore.service';
import { GroupService } from '../../Group/group.service';
import { ProjectService } from '../../Project/project.service';
import { DefaultProjectTemplateEnum } from '@smarttask-common/src/lib/models/Internal/DefaultSetup/DefaultProjectTemplateEnum';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { SharedEventModel } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventModel';
import { SharedService } from '../../AngularSpecific/shared.service';
import { Capacitor } from '@capacitor/core';
import { MobLocalStorageService } from '@smarttask-common/src/lib/services/General/mob-local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class DefaultSetupService {
    default_projects_processing_count = signal<number>(0);
    onboardingProjectToastrRef: ActiveToast<any>;
    constructor(
        private globals: Globals,
        private toastr: ToastrService,
        private sanitizer: DomSanitizer,
        private sharedService: SharedService,
        private organizationStoreService: OrganizationStoreService,
        private groupService: GroupService,
        private projectService: ProjectService,
        private mobLocalStorageService: MobLocalStorageService,
    ) {
        this.listenToProjectCopied();
    }

    getDefaultSetupOptions = (vertical: InternalRegistrationVerticalEnum): DefaultSetupGroupModel[] => {
        let groups: DefaultSetupGroupModel[] = [];
        switch (vertical) {
            case InternalRegistrationVerticalEnum.accounting:
                groups = [
                    {
                        group_name: 'Ongoing Work',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.GST_Filing,
                                name: 'GST Filing',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Support_Tickets,
                                name: 'Support Tickets',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Audit Projects',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Corporate_Audit,
                                name: 'Macmillan Audit',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Clients',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Account_Management,
                                name: 'Clients Overview',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects:[
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ]
                    },
                    {
                        group_name: 'Management',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.All_Hands_Meeting,
                                name: 'All Hands Meeting',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    }
                ];
                break;
            case InternalRegistrationVerticalEnum.architecture:
                groups = [
                    {
                        group_name: 'Architecture Projects',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Architecture_Design,
                                name: 'Aurora Tower',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Interior Projects',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Interior_Design,
                                name: 'Jackson Villa',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.automotive:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Procurement',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    }
                ];
                break;
            case InternalRegistrationVerticalEnum.construction:
                groups = [
                    {
                        group_name: 'Projects',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Construction_Roadmap,
                                name: 'Construction Roadmap',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Procurement',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Management',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Site_Tracking,
                                name: 'Site Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    }
                ];
                break;
            case InternalRegistrationVerticalEnum.d2c:
                groups = [
                    {
                        group_name: 'R&D',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.New_Product_Development,
                                name: 'NPD-001',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ]
                    },
                    {
                        group_name: 'Operations',
                        projects:[
                            {
                                template_id: DefaultProjectTemplateEnum.Order_Tracker,
                                name: 'Order Tracker',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ]
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Marketing_Campaign,
                                name: 'Marketing Campaign',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.design:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Operations',
                        projects: [
                            
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Design,
                                name: 'Apple New Website',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Rebranding,
                                name: 'Samsung ReBranding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Creative_Requests,
                                name:'Creative Requests',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true
                            }
                        ],
                    },
                    {
                        group_name: 'Video Team',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Short_Video,
                                name: 'Short Video Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Long_Video,
                                name: 'Long Video Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Marketing_Campaign,
                                name: 'Marketing Campaign',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Management',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.All_Hands_Meeting,
                                name: 'All Hands Meeting',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Expense_Tracking,
                                name: 'Expense Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Database,
                                name: 'Employee Database',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.distribution:
                groups = [
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Analytics,
                                name: 'Social Media Tracker',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Training_Management,
                                name: 'Employee Training Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    }
                ];
                break;
            case InternalRegistrationVerticalEnum.education:
                groups = [
                    {
                        group_name: 'Admissions & Enrollment',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Student_Tracking,
                                name: 'Student Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Admin',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Support_Tickets,
                                name: 'Support Requests',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                                                        {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Analytics,
                                name: 'Social Media Tracker',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.LMS_Tracking_Course,
                                name: 'LMS Maintenance',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Email_Marketing_Calendar,
                                name: 'Email Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Management',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.All_Hands_Meeting,
                                name: 'All Hands Meeting',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Expense_Tracking,
                                name: 'Expense Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Training_Management,
                                name: 'Employee Training Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    }
                ];
                break;
            case InternalRegistrationVerticalEnum.event_management:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Events',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Event_Management,
                                name: 'Veritone Labs Event',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Guest_Management,
                                name: 'Guest Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ],
                    },
                    {
                        group_name: 'Database',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Event_Venues,
                                name: 'Event Venues',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Event_Vendors,
                                name: 'Vendors',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Analytics,
                                name: 'Social Media Tracker',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Training_Management,
                                name: 'Employee Training Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    }
                ];
                break;
            case InternalRegistrationVerticalEnum.facility_management:
                groups = [
                    {
                        group_name: 'Operations',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Support_Tickets,
                                name: 'Service Requests',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ]
                    }
                ]
                break;
            case InternalRegistrationVerticalEnum.financial_services:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ],
                    },
                    {
                        group_name: 'Management',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.All_Hands_Meeting,
                                name: 'All Hands Meeting',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Expense_Tracking,
                                name: 'Expense Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },

                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.FMCG:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Client_Inquiries,
                                name: 'Inquiries',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ],
                    },
                    {
                        group_name: 'Operations',
                        projects:[
                            {
                                template_id: DefaultProjectTemplateEnum.Order_Tracker,
                                name: 'Order Tracker',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ]
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Training_Management,
                                name: 'Employee Training Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.game:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Inquiries',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Team A',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Feature_Development,
                                name: 'Northstar Project',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Website Project',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ],
                    },
                    {
                        group_name: 'Product Team',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Backlogs_And_Sprints,
                                name: 'Product Sprint',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Bug_and_Issue_Tracking,
                                name: 'Bug & Issue Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects:[
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ]
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },

                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Customer Success',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.IT_Support_Ticket,
                                name: 'Support Tickets',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.government:
                groups = [
                    {
                        group_name: 'Projects',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Construction_Roadmap,
                                name: 'Construction Roadmap',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Procurement',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.healthcare:
                groups = [
                    {
                        group_name: 'Projects',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Construction_Roadmap,
                                name: 'Construction Roadmap',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Procurement',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.hr_recruitment:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Client_Inquiries,
                                name: 'Inquiries',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ],
                    },
                    {
                        group_name: 'Operations',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Applicant Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Client_HR_Requirements,
                                name: 'Client Requirements',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ]
                    },
                    {
                        group_name: 'Database',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Candidate_Database,
                                name: 'Candidate Database',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ]
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Training_Management,
                                name: 'Employee Training Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.incubators:
                groups = [
                    {
                        group_name: 'Grants',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Grants_Projects,
                                name: 'Grants Projects',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Database',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Event_Vendors,
                                name: 'Vendors',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Investors_Database,
                                name: 'Investors Database',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Marketing_Campaign,
                                name: 'Marketing Campaign',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Procurement',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.legal:
                groups = [
                    {
                        group_name: 'Operations',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Legal_Agreement_Management,
                                name: 'Ad-Hoc Work',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Case_Management,
                                name: 'Northstar Vs Jackson',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },

                    {
                        group_name: 'Management',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.All_Hands_Meeting,
                                name: 'All Hands Meeting',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.manufacturing:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Operations',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Order_Tracker,
                                name: 'Quick Order Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Machine_Manufacturing,
                                name: 'Long Order Project',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Procurement',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Customer Support',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Support_Tickets,
                                name: 'Support Ticket Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.marketing:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Inquiries',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Team A',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Projects',
                        projects:[
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Design,
                                name: 'Genesys New Website',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Primary_Research_Plan,
                                name: 'Cogen Primary Research',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Branding,
                                name: 'Pathwise Branding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ]
                    },
                    {
                        group_name: 'Clients',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Account_Management,
                                name: 'Active Clients',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.SEO_Ongoing_Work,
                                name: 'Macmillan Ongoing Work',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ],
                    },
                    {
                        group_name: 'Video Team',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Short_Video,
                                name: 'Short Video Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Long_Video,
                                name: 'Macmillan Video Campaign',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.non_profit:
                groups = [
                    {
                        group_name: 'Operations',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Fund_Raising,
                                name: 'Educate Girl - 2025 - Fund Raising',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.All_Hands_Meeting,
                                name: 'Managment Report',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },

                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.operations:
                groups = [
                    {
                        group_name: 'Projects',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Construction_Roadmap,
                                name: 'Construction Roadmap',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Procurement',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.personal:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Inquiries',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects:[
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ]
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.pharma:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Operations',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Order_Tracker,
                                name: 'Quick Order Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Machine_Manufacturing,
                                name: 'Long Order Project',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Procurement',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Procurement,
                                name: 'Procurement',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Customer Support',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Support_Tickets,
                                name: 'Support Ticket Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.real_estate:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Real_Estate_CRM,
                                name: 'Real Estate CRM',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Operations',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Real_Estate_Management,
                                name: 'Real Estate Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Inventory',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Properties_for_Lease,
                                name: 'Properties for Lease',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Properties_for_Selling,
                                name: 'Properties for Selling',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    }
                ];
                break;
            case InternalRegistrationVerticalEnum.sales_crm:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Lead_Tracking,
                                name: 'Lead Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.saas:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Inquiries',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Product Team',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Backlogs_And_Sprints,
                                name: 'Product Work',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Feature_Requests,
                                name: 'Feature Requests',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Bug_and_Issue_Tracking,
                                name: 'Bug & Issue Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Implementation',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Onboarding,
                                name: 'SparkCo Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Customer Success',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Account_Management,
                                name: 'Customer Account Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.software:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Inquiries',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Team A',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Feature_Development,
                                name: 'Northstar Project',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Website Project',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ],
                    },
                    {
                        group_name: 'Product Team',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Backlogs_And_Sprints,
                                name: 'Product Sprint',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Bug_and_Issue_Tracking,
                                name: 'Bug & Issue Tracking',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects:[
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            }
                        ]
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },

                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Customer Success',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.IT_Support_Ticket,
                                name: 'Support Tickets',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.solar:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Projects',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Solar_Project,
                                name: 'Synergy Group - 1MW',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    
                    {
                        group_name: 'Service',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Support_Tickets,
                                name: 'Service Requests',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.system_integrators:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Projects',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Onboarding,
                                name: 'SetMax Implementation',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Support_Tickets,
                                name: 'Support Tickets',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Integration Partners',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Partners,
                                name: 'Partners',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Clients',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Account_Management,
                                name: 'Clients Overview',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Management',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.All_Hands_Meeting,
                                name: 'All Hands Meeting',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ];
                break;
            case InternalRegistrationVerticalEnum.travel:
                groups = [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Inquiries',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production - A',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Calendar,
                                name: 'Social Media Calendar',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Social_Media_Analytics,
                                name: 'Social Media Tracker',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Email_Marketing_Calendar,
                                name: 'Email Campaigns',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Operations',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Itinerary_Approval,
                                name: 'Jack - NY - Itinerary',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Resources',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Trip_and_Package_Name,
                                name: 'Trip & Package Name',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Customer Success',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Customer_Support_Tickets,
                                name: 'Support Tickets',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Hiring,
                                name: 'Hiring',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Training_Management,
                                name: 'Employee Training Management',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },                    
                ];
                break;
            
            case InternalRegistrationVerticalEnum.business_consultancy:
            case InternalRegistrationVerticalEnum.others:
                groups =  [
                    {
                        group_name: 'Sales',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Deal_Pipeline,
                                name: 'Deal Pipeline',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Marketing',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Website_Content_Calendar,
                                name: 'Content Production',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Management',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.All_Hands_Meeting,
                                name: 'All Hands Meeting',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'Accounts',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Payable,
                                name: 'Accounts Payable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                            {
                                template_id: DefaultProjectTemplateEnum.Accounts_Receivable,
                                name: 'Accounts Receivable',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                    {
                        group_name: 'HR',
                        projects: [
                            {
                                template_id: DefaultProjectTemplateEnum.Employee_Onboarding,
                                name: 'Employee Onboarding',
                                color_id: Math.floor(Math.random() * 16),
                                selected: true,
                            },
                        ],
                    },
                ]
                break;
        }
        return groups;
    };

    createOnboardingGroups = async () => {
        const default_setup_groups: DefaultSetupGroupModel[] = Capacitor.isNativePlatform()
            ? await this.mobLocalStorageService.getObject(this.globals.local_storage_names.st_default_setup_groups).catch(() => undefined)
            : localStorage.getItem(this.globals.local_storage_names.st_default_setup_groups)
              ? JSON.parse(localStorage.getItem(this.globals.local_storage_names.st_default_setup_groups))
              : undefined;
        if (default_setup_groups == undefined) {
            return;
        }
        const promises: Array<Promise<any>> = [];
        let groups_with_selected_project = default_setup_groups.filter(x=> x.projects.some(p=> p.selected));
        for (let g of groups_with_selected_project) {
            const group = new GroupBaseModel();
            group.name = g.group_name;
            promises.push(
                this.groupService.create(group).then((group) => {
                    const projects = g.projects.filter((p) => p.selected);
                    if (projects.length > 0) {
                        projects.forEach((p) => this.createOnboardingProject(p, group.group_id));
                    }
                }),
            );
        }
        Promise.allSettled(promises).then((_) => {
            console.log('Default setup groups created');
            this.createProjectProcessingToast();
            if (Capacitor.isNativePlatform()) {
                this.mobLocalStorageService.remove(this.globals.local_storage_names.st_default_setup_groups);
            } else {
                localStorage.removeItem(this.globals.local_storage_names.st_default_setup_groups);
            }
        });
    };

    createOnboardingProject = (default_project: DefaultSetupProjectModel, group_id: number) => {
        const project_copy = new ProjectCopyModel(false);
        project_copy.record_copy_info.copy_reminders = true;
        project_copy.created_by_user_id = this.globals.auth_data.user_id;
        project_copy.original_project_id = default_project.template_id;
        project_copy.in_group_id = group_id;
        project_copy.in_organization_id = this.organizationStoreService.getSelectedOrganizationId();
        project_copy.new_project.name = default_project.name;
        project_copy.new_project.start_date = new Date();
        project_copy.new_project.start_date.setHours(0, 0, 0, 0);

        this.default_projects_processing_count.update((x) => x + 1);

        return this.projectService.copyProject(project_copy, false);
    };

    createProjectProcessingToast = () => {
        const message = this.sanitizer.bypassSecurityTrustHtml(
            `<div class="d-flex align-items-center gap-2">
                        <svg-icon class="st-spinner d-flex align-items-center" src="assets/images/common/svg/spinner.svg" [svgClass]="'st-svg-20'"></svg-icon>
                        <span id="stOnboardingProjectToastMsg">Creating ${this.default_projects_processing_count()} projects...</span>
                    </div>`,
        ) as string;
        this.onboardingProjectToastrRef = this.toastr.show(message, '', {
            toastClass: 'custom-toast white-toast border-blue',
            titleClass: 'custom-title',
            messageClass: 'custom-message',
            enableHtml: true,

            timeOut: 3 * 60 * 1000,
            tapToDismiss: true,
            closeButton: true,
        });
    };

    checkDefaultProjectProcessingCount = async () => {
        const data = Capacitor.isNativePlatform()
            ? await this.mobLocalStorageService.get(this.globals.local_storage_names.st_default_projects_processing_count).catch(() => undefined)
            : window.localStorage.getItem(this.globals.local_storage_names.st_default_projects_processing_count);
        if (!data) return;
        const { organiazation_id, count } = JSON.parse(data);
        if (organiazation_id != this.organizationStoreService.getSelectedOrganizationId()) {
            return;
        }
        if (count > 0) {
            this.default_projects_processing_count.set(count);
            this.createProjectProcessingToast();
        }
        if (Capacitor.isNativePlatform()) {
            this.mobLocalStorageService.remove(this.globals.local_storage_names.st_default_projects_processing_count);
        } else {
            window.localStorage.removeItem(this.globals.local_storage_names.st_default_projects_processing_count);
        }
    };

    updateDefaultProjectProcessingCount = (count: number) => {
        if (count > 0) {
            this.default_projects_processing_count.set(count);
            const msg_elem = document.getElementById('stOnboardingProjectToastMsg') as HTMLElement;
            if (msg_elem) {
                msg_elem.innerText = `Creating ${this.default_projects_processing_count()} projects...`;
            }
        } else if (this.onboardingProjectToastrRef) {
            this.toastr.remove(this.onboardingProjectToastrRef.toastId);
            this.onboardingProjectToastrRef = undefined;
        }
    };

    listenToProjectCopied = () => {
        this.sharedService.on(SharedEventNameEnum.project_copied, (event: SharedEventModel) => {
            const old_project_id: string = event.obj?.old_project_id;
            const new_project_id: string = event.obj?.new_project_id;
            if (this.default_projects_processing_count() > 0) {
                this.updateDefaultProjectProcessingCount(this.default_projects_processing_count() - 1);
            }
        });
    };
}
